<template>
	<PageArrows 
		v-bind:className="'patient'"
		v-bind:linkPrev="`/patient/${which}/${content[which].prevTab}`"
		v-bind:linkNext="`/patient/${which}/${content[which].nextTab}`"
		v-bind:linkNextInterim="content[which].nextTabInterim"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:load-interim="loadInterim"
	></PageArrows>
	<ColumnLayout
		v-bind:which="which"
		v-bind:tabType="tabType"
		v-bind:content="content"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:show-overlay="showOverlay"
	></ColumnLayout>
	<teleport to="body">
		<QuestionPopup
			v-if="content[which].InterimQA && questionPopupDisplay && !content[which].interimQAmultiple"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:close-then="closeThen"
		></QuestionPopup>

		<QuestionPopupMultiple
			v-if="content[which].InterimQA && questionPopupDisplay && content[which].interimQAmultiple === true"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:close-then="closeThen"
		></QuestionPopupMultiple>
	</teleport>
	<teleport to="body">
		<ScheduleExample
			v-if="content[which].ScheduleExample && scheduleExampleDisplay"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:show-overlay="showOverlay"
		></ScheduleExample>
	</teleport>
</template>
<script>
import PageArrows from '@/components/PageArrows'
import ColumnLayout from '@/components/ColumnLayout'
import QuestionPopup from '@/components/QuestionPopup'
import QuestionPopupMultiple from '@/components/QuestionPopupMultiple'
import ScheduleExample from '@/components/ScheduleExample'
export default {
	components: {
		PageArrows,
		ColumnLayout,
		QuestionPopup,
		QuestionPopupMultiple,
		ScheduleExample
	},
	data() {
		return {
			which: this.$route.params.which,
			tabType: 'pre-initiation',
			questionPopupDisplay: false,
			scheduleExampleDisplay: false,
			content: {
				bishop: {
					prevTab: 'risk-assessment/',
					nextTab: 'ramp-up/',
					nextTabInterim: true,
					columnA: 275,
					columnB: 329,
					columnC: 310,
					columnChide: true,
					InterimQA: {
						layoutClass: 'two-col',
						type: 'radio',
						question: 'How would you manage Mr. Bishop’s ramp-up considering the concurrent administration of diltiazem, a moderate CYP3A inhibitor?',
						choices: [
							'Venetoclax dosing should be reduced to a steady daily dose of 100 mg',
							'Diltiazem is contraindicated with venetoclax ramp-up in CLL and should be discontinued prior to treatment initiation',
							'Venetoclax dosing should be reduced by at least 50%, to a steady daily dose <br> of 200 mg',
							'This would not impact venetoclax ramp-up'
						],
						answer: '2',
						answerSize: 957,
						redirect: '/patient/bishop/ramp-up/'
					}
				},
				pierce: {
					prevTab: 'diagnosis/',
					nextTab: 'cycle-1/',
					nextTabInterim: true,
					columnA: 664,
					columnB: 266,
					columnBbutton: 254,
					columnButtonAction: 'show-schedule-example',
					interimQAmultiple: true,
					InterimQA: [
						{
							layoutClass: 'two-col',
							type: 'radio',
							question: 'What management step is necessary for  Mrs. Pierce prior to venetoclax dose initiation based on the collected information?',
							choices: [
								'Extend the ramp-up due to her high WBC count',
								'Perform cytoreduction to WBC <25 × 10⁹/L',
								'Administer additional IV hydration and rasburicase due <br>to concurrent fluconazole use',
								'Discontinue fluconazole given the drug-drug interaction'
							],
							answer: '1',
							answerSize: 957,
							redirect: null,
							nextQ: 1
						},
						{
							layoutClass: 'two-col',
							type: 'radio',
							question: 'How would you plan to modify Mrs. Pierce’s planned ramp-up dose based on the concurrent use of fluconazole, a moderate CYP3A inhibitor?',
							choices: [
								'Postpone ramp-up',
								'Reduce the venetoclax dose by at least 50%',
								'Reduce the venetoclax steady daily dose to 100 mg',
								'Would not change the venetoclax steady daily dose'
							],
							answer: '-1',
							answerLong: 'Reduce the venetoclax dose by at least 50% (steady daily dose of 200 mg or less) due to concurrent administration of a moderate CYP3A inhibitor.',
							answerSize: 957,
							redirect: '/patient/pierce/cycle-1/'
						},
					],
					ScheduleExample: {
						classes: 'pre-initiation-pierce',
						dirpath: 'patients',
						title: 'VEN+AZA AND VEN+DEC INITIATION SCHEDULE EXAMPLE',
						title_sup: 1,
						noArrows: true,
						tabs: {
							tab0: {
								name: "VEN+AZA",
								panels: [
									{
										img_main: 892
									},
								]
							},
							tab1: {
								name: "VEN+DEC",
								panels: [
									{
										img_main: 892
									},
								]
							}
						}	
					}
				}
			}
		}
	},
	methods: {
		loadInterim(){
			this.questionPopupDisplay = true
		},
		closeThen(redirect){
			if(redirect){
				this.$router.push(redirect)
			}
		},
		showOverlay(whichActions){
			switch(whichActions[0]){
				case 'show-overlay':
						this.overlayDisplay = whichActions[1]
					break;
				case 'show-schedule-example':
						this.scheduleExampleDisplay = whichActions[1]
					break;

			}
		}
	}
}
</script>